import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=81fddc90&scoped=true&"
var script = {}
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=81fddc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fddc90",
  null
  
)

export default component.exports